export enum Lang {
  en = 'en',
  tr = 'tr',
}
